import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import './App.css';

function About() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];

  return (
    <div className="page">
      <header className="topbar">
        <Link to="/" className="brand">
          <img src="/velyntor_logo-removebg-preview.png" alt="Velyntor" className="brand-logo" />
        </Link>
        <div className="brand-center">VELYNTOR</div>
        <button
          className={`menu-toggle ${menuOpen ? 'open' : ''}`}
          aria-label="Öppna meny"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="topbar-right">
          <nav className={`nav ${menuOpen ? 'open' : ''}`}>
            <Link to="/" onClick={() => setMenuOpen(false)}>
              {t.automation}
            </Link>
            <Link to="/marknadsforing" onClick={() => setMenuOpen(false)}>
              {t.marketing}
            </Link>
            <Link to="/webbutveckling" onClick={() => setMenuOpen(false)}>
              {t.webDevelopment}
            </Link>
            <Link to="/om-oss" onClick={() => setMenuOpen(false)}>
              {t.about}
            </Link>
            <Link to="/kontakt" onClick={() => setMenuOpen(false)}>
              {t.contact}
            </Link>
            <Link to="/kontakt" className="ghost-btn mobile-only" onClick={() => setMenuOpen(false)}>
              {t.bookMeeting}
            </Link>
            <button className="language-toggle mobile-only" onClick={toggleLanguage}>
              <img 
                src="https://flagcdn.com/w20/se.png" 
                alt="Svenska" 
                className={`flag-icon ${language === 'sv' ? 'active' : ''}`}
              />
              <span>/</span>
              <img 
                src="https://flagcdn.com/w20/gb.png" 
                alt="English" 
                className={`flag-icon ${language === 'en' ? 'active' : ''}`}
              />
            </button>
          </nav>
          <button className="language-toggle desktop-only" onClick={toggleLanguage}>
            <img 
              src="https://flagcdn.com/w20/se.png" 
              alt="Svenska" 
              className={`flag-icon ${language === 'sv' ? 'active' : ''}`}
            />
            <span>/</span>
            <img 
              src="https://flagcdn.com/w20/gb.png" 
              alt="English" 
              className={`flag-icon ${language === 'en' ? 'active' : ''}`}
            />
          </button>
        </div>
      </header>

      <main>
        <section className="hero contact-hero">
          <div className="hero-text">
            <p className="eyebrow">{t.aboutEyebrow}</p>
          </div>
        </section>

        <div className="about-content">
          <div className="about-text">
            <p>
              {t.aboutText1}
            </p>
            <p>
              {t.aboutText2}
            </p>
            <p>
              {t.aboutText3}
            </p>
            <p>
              {t.aboutText4}
            </p>
          </div>
        </div>

        <section id="contact" className="section cta">
          <div>
            <p className="eyebrow">{t.contact}</p>
            <h2>{t.contactSubtitle}</h2>
            <p className="section-sub">
              {t.contactDescription}
            </p>
          </div>
          <div className="cta-actions">
            <Link to="/kontakt" className="primary-btn">{t.bookMeeting}</Link>
            <a href="mailto:info@velyntor.se" className="secondary-btn">{t.email}</a>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>{t.footerContact}</h4>
            <p style={{ marginTop: '8px' }}>
              <a href="mailto:info@velyntor.se">{t.email}</a>
            </p>
            <p style={{ marginTop: '4px' }}>
              <a href="tel:+46700252952">+46 70 025 29 52</a>
            </p>
            <p style={{ marginTop: '4px' }}>
              <a href="https://linkedin.com/company/techblaze-ab/" target="_blank" rel="noreferrer">
                LinkedIn
              </a>
            </p>
          </div>
          <div className="footer-section">
            <h4>{t.footerPages}</h4>
            <div className="footer-links">
              <Link to="/">{t.automation}</Link>
              <Link to="/marknadsforing">{t.marketing}</Link>
              <Link to="/webbutveckling">{t.webDevelopment}</Link>
              <Link to="/om-oss">{t.about}</Link>
              <Link to="/kontakt">{t.contact}</Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div>© {new Date().getFullYear()} Velyntor. {t.footerRights}</div>
        </div>
      </footer>
    </div>
  );
}

export default About;

